import { render, staticRenderFns } from "./nav-app-mobile.vue?vue&type=template&id=1c582613&scoped=true"
import script from "./nav-app-mobile.vue?vue&type=script&lang=js"
export * from "./nav-app-mobile.vue?vue&type=script&lang=js"
import style0 from "./nav-app-mobile.vue?vue&type=style&index=0&id=1c582613&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c582613",
  null
  
)

export default component.exports